import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigService } from './config.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./config.service";
export class CapacitacionService {
    constructor(http, configService) {
        this.http = http;
        this.configService = configService;
        this.jsonContent = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': sessionStorage.getItem('batoken'),
                'User': sessionStorage.getItem('userid')
            })
        };
        this.headers = new HttpHeaders();
    }
    create(capacitacion, rutTrabajadores) {
        const body = JSON.stringify({ newCapacitacion: capacitacion, rutTrabajadores });
        console.log("paso por acá antes de irme");
        console.log(body);
        return this.http.post(`${this.configService.API_URL}/capacitaciones/reforzamiento`, body, Object.assign({}, this.jsonContent, { responseType: 'text' })).toPromise();
    }
    // public update(capacitacion: any, capacitacionId: number, rutTrabajadores: string[]): Promise<any> {
    //   const userid = sessionStorage.getItem('userid');
    //   const body = JSON.stringify({ userid, capacitacionId, capacitacion, rutTrabajadores});
    //   return this.http.put(
    //     `${this.configService.API_URL}/capacitaciones/${capacitacionId}`,
    //     body,
    //     { ...this.jsonContent, responseType: 'json' }).toPromise();
    // }
    // public update(capacitacion: any, capacitacionId: number, rutTrabajadores: string[]): Promise<any> {
    //   const userid = sessionStorage.getItem('userid');
    //   const body = JSON.stringify({ capacitacion: capacitacion, rutTrabajadores });
    //   return this.http.put(
    //     `${this.configService.API_URL}/capacitaciones/${capacitacionId}`,
    //     body,
    //     { ...this.jsonContent, responseType: 'text' }).toPromise();
    // }
    getAsistentes(capacitacionId) {
        return this.http.get(`${this.configService.API_URL}/capacitaciones/find-asistentes?capacitacionId=${capacitacionId}`, Object.assign({}, this.jsonContent, { responseType: 'json' })).toPromise();
    }
    update(capacitacion, capacitacionId, rutTrabajadores) {
        const body = JSON.stringify({ capacitacion, rutTrabajadores });
        return this.http.put(`${this.configService.API_URL}/capacitaciones/${capacitacionId}`, body, Object.assign({}, this.jsonContent, { responseType: 'text' })).toPromise();
    }
    delete(capacitacionId) {
        return this.http.delete(`${this.configService.API_URL}/capacitaciones/${capacitacionId}`, Object.assign({}, this.jsonContent, { responseType: 'text' })).toPromise();
    }
    getCapacitacion(capacitacionId) {
        return this.http.get(`${this.configService.API_URL}/capacitaciones/${capacitacionId}`, Object.assign({}, this.jsonContent, { responseType: 'json' })).toPromise();
    }
    list(offset, quantity, year, month, contratista, empresa, zona) {
        const userid = sessionStorage.getItem('userid');
        return this.http.get(`${this.configService.API_URL}/capacitaciones?offset=${offset}&quantity=${quantity}&user=${userid}&year=${year}&month=${month}&contratista=${contratista}&empresa=${empresa}&zona=${zona}`, Object.assign({}, this.jsonContent)).toPromise();
    }
    listPagination(page = 1, size = 10, year, month, contratista, empresa, zona) {
        const userid = sessionStorage.getItem('userid');
        return this.http.get(`${this.configService.API_URL}/capacitaciones/pagination?page=${page}&size=${size}&user=${userid}&year=${year}&month=${month}&contratista=${contratista}&empresa=${empresa}&zona=${zona}`, Object.assign({}, this.jsonContent)).toPromise();
    }
    getTotalAmmout(year, month, contratista, empresa, zona) {
        const userid = sessionStorage.getItem('userid');
        return this.http.get(`${this.configService.API_URL}/capacitaciones/ammount?user=${userid}&year=${year}&month=${month}&contratista=${contratista}&empresa=${empresa}&zona=${zona}`, Object.assign({}, this.jsonContent, { responseType: 'text' })).toPromise();
    }
    accept(capacitacionId, userID, motivoID, comentario) {
        const body = JSON.stringify({ userID, motivoID, comentario });
        return this.http.patch(`${this.configService.API_URL}/capacitaciones/${capacitacionId}/accept`, body, Object.assign({}, this.jsonContent, { responseType: 'text' })).toPromise();
    }
    reject(capacitacionId, userID, motivoID, comentario) {
        const body = JSON.stringify({ userID, motivoID, comentario });
        return this.http.patch(`${this.configService.API_URL}/capacitaciones/${capacitacionId}/reject`, body, Object.assign({}, this.jsonContent, { responseType: 'text' })).toPromise();
    }
    getCapacitacionesCalendario(userId, rolId) {
        return this.http.get(`${this.configService.API_URL}/capacitaciones/find-capacitaciones-calendario?userId=${userId}&rol=${rolId}`, Object.assign({}, this.jsonContent, { responseType: 'json' })).toPromise();
    }
    getRefuerzoCapacitacion(idPlan) {
        return this.http.get(`${this.configService.API_URL}/capacitaciones/obtener-refuerzo-capacitacion/${idPlan}`, Object.assign({}, this.jsonContent, { responseType: 'json' })).toPromise();
    }
    getStatusCapacitacion(idPlan) {
        return this.http.get(`${this.configService.API_URL}/capacitaciones/obtener-status-capacitacion/${idPlan}`, Object.assign({}, this.jsonContent, { responseType: 'json' })).toPromise();
    }
    getTipoArchivosActivos() {
        return this.http.get(`${this.configService.API_URL}/tipoArchivo`, Object.assign({}, this.jsonContent, { responseType: 'json' })).toPromise();
    }
    getTipoArchivosActivosPorTipo(tipo) {
        return this.http.get(`${this.configService.API_URL}/tipoArchivo/${tipo}/tipo`, Object.assign({}, this.jsonContent, { responseType: 'json' })).toPromise();
    }
}
CapacitacionService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CapacitacionService_Factory() { return new CapacitacionService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.ConfigService)); }, token: CapacitacionService, providedIn: "root" });
